import { render, staticRenderFns } from "./BasisForm.vue?vue&type=template&id=43f0191d&scoped=true"
import script from "./BasisForm.vue?vue&type=script&lang=js"
export * from "./BasisForm.vue?vue&type=script&lang=js"
import style0 from "./BasisForm.vue?vue&type=style&index=0&id=43f0191d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0191d",
  null
  
)

export default component.exports